module.exports = __webpack_public_path__ + "img/number_03.b761848a.svg";